import { useEffect, useState } from "react";
import {
  useHistory,
  useLocation,
} from "react-router-dom/cjs/react-router-dom.min";
import "../../assets/styles/local/Stock.css";
import Header from "../../layouts/Header";
import moment from "moment";
import "../../assets/styles/local/payroll.css";
import simpleRequest from "../../utils/helpers/simpleRequest";
import { europeanFormatWithSymbol } from "../../utils/European-Format/NumberFormatter";
import Pagination from "../../components/Pagination/Pagination";
import { Image } from "react-bootstrap";
import packageIcn from "../../assets/icons/sendWhite.svg";
import { Modal } from "antd";
import { fetchScreenTranslations } from "../../utils/helpers/translations";
const PayrollStatus = () => {
  const history = useHistory();
  const {
    state: { state },
  } = useLocation();
  const [rows, setRows] = useState([]);
  const [perPage, setPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  useEffect(() => {
    setCurrentPage(0);
  }, [perPage, currentPage]);

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Payroll").then((data) =>
      setFetchTranslationList(data)
    );
  }, []);

  const calculateNetWage = (grosswage, employeeTax) => grosswage - employeeTax;
  const calculateTotalPayrollCost = (grosswage, companyTax) =>
    +grosswage + +companyTax;

  const handleSubmit = async () => {
    const payload = {
      payrollHistoryId: rows[0].payrollHistoryId,
      statusId: "08dab011-a6cf-4069-887e-83e5f3473116",
    };
    const resp = await simpleRequest(
      `/api/Payroll/UpdatePayrollstatus`,
      "post",
      payload
    );
    if (resp?.status === true) history.goBack();
  };

  const fetchPayrollById = async () => {
    const resp = await simpleRequest(`/api/Payroll/FetchPayrollById`, "post", {
      payrollHistoryId: state.payrollHistoryId ?? "",
      pagerequire: perPage,
      pagenumber: currentPage + 1,
    });
    if (resp?.status) {
      // Initialize all items as selected
      const updatedData = resp.data.map((item) => ({
        ...item,
        payrollExpense: item.payrollExpense.map((expense) => ({
          ...expense,
          selected: true, // Set all items as selected
        })),
      }));
      setRows(updatedData);
      setSelectAll(true);
      const totalRecords =
        resp?.data?.totalCount ?? resp?.data[0]?.payrollExpense.length;
      const newTotalPages = Math.ceil(totalRecords / perPage);
      setTotalPages(newTotalPages);
    }
  };

  useEffect(() => {
    fetchPayrollById();
  }, [perPage, currentPage]);

  const [selectAll, setSelectAll] = useState(false);

  // Handler to toggle "Select All"
  const handleSelectAllToggle = () => {
    const updatedRows = [...rows];
    const isChecked = !selectAll; // Toggle the selectAll state
    updatedRows[0].payrollExpense = updatedRows[0]?.payrollExpense.map(
      (expense) => ({
        ...expense,
        selected: isChecked,
      })
    );
    setRows(updatedRows);
    setSelectAll(isChecked);
  };

  // Handler to toggle individual item selection
  const handleItemToggle = (index) => {
    const updatedRows = [...rows];
    const item = updatedRows[0].payrollExpense[index];
    item.selected = !item.selected;

    // Update rows and dynamically adjust "Select All" status
    setRows(updatedRows);

    const allSelected = updatedRows[0].payrollExpense.every(
      (item) => item.selected
    );
    setSelectAll(allSelected);
  };
  return (
    <>
      <Header
        leftComponent={
          <div className="products-and-parts-header-content">
            <div
              className="products-and-parts-main-title  cursor-pointer"
              onClick={() => {
                history.push("/payroll");
              }}
            >
              {/* Payroll */}
              {t("Payroll")}
            </div>
            <p className="products-and-parts-sub-title products_and_parts_sub_title">
              {/* Submit */}
              {t("Submit")}
            </p>
          </div>
        }
      />
      <div className="container-fluid mainWrapper ">
        <div className=" stock row col-12">
          <div className="col-sm-12 stockCards">
            <div className="payroll-container col-sm-12 mb-2">
              <div className="col-sm-3">
                {/* Pay period */}
                {t("Pay period")}:{" "}
                <span className="pay-period">
                  {moment(rows[0]?.payrollPeriodStart).format("DD MMM")} -{" "}
                  {moment(rows[0]?.payrollPeriodEnd).format("DD MMM")}
                </span>
              </div>
              <div className="col-sm-3 d-flex gap-2">
                {/* Total Net Wages */}
                {t("Total Net Wages")}:{" "}
                <span className="pay-period">
                  {europeanFormatWithSymbol(
                    rows[0]?.payrollExpense.reduce(
                      (acc, curr) =>
                        acc +
                        calculateNetWage(curr.grosswage, curr.employeeTax),
                      0
                    )
                  )}
                </span>
              </div>
              <div className="col-sm-3 d-flex justify-content-end">
                <div
                  className="pro-part-add-itm-btn d-flex"
                  onClick={() => setIsModalOpen(true)}
                >
                  <Image height={20} width={20} src={packageIcn} />
                  <div className="pro-part-add-itm-btn-text">
                    {/* Submit */}
                    {t("Submit")}
                  </div>
                </div>
              </div>
            </div>
            <div
              className="tableWrapper-payroll"
              style={{ overflowY: "auto", minHeight: "calc(100vh - 200px)" }}
            >
              <div>
                <table className="table offcyc-table mb-0">
                  <thead>
                    <tr className="off-cycle-header">
                      <th>
                        {/* Members */}
                        {t("Members")}
                      </th>
                      <th>
                        {/* Gross Wage */}
                        {t("Gross Wage")}
                      </th>
                      <th>
                        {/* Employee Taxes */}
                        {t("Employee Taxes")}
                      </th>
                      <th
                        style={{
                          fontWeight: "bold",
                          color: "#707070",
                        }}
                      >
                        {/* Net Wage */}
                        {t("Net Wage")}
                      </th>
                      <th>
                        {/* Company Taxes */}
                        {t("Company Taxes")}
                      </th>
                      <th style={{ fontWeight: "bold", color: "#707070" }}>
                        {/* Total Payroll Cost */}
                        {t("Total Payroll Cost")}
                      </th>
                      <th className="d-flex align-items-center gap-2">
                        <input
                          disabled
                          id="purchasing"
                          type="checkbox"
                          checked={selectAll}
                          onChange={handleSelectAllToggle}
                        />
                        {selectAll ? (
                          <label htmlFor="purchasing" className="pointer">
                            {/* Unselect All */}
                            {t("Unselect All")}
                          </label>
                        ) : (
                          <label htmlFor="purchasing" className="pointer">
                            {/* Select All */}
                            {t("Select All")}
                          </label>
                        )}
                      </th>
                    </tr>
                  </thead>
                  <tbody style={{ border: "none" }}>
                    {rows[0]?.payrollExpense?.map((row, index) => (
                      <tr key={index} className="edit-payroll-row">
                        <td
                          style={{
                            padding: "0.5rem 0.75rem",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            width: "160px",
                            textOverflow: "ellipsis",
                            display: "block",
                          }}
                        >
                          {row.username}
                        </td>
                        <td style={{ padding: "0.5rem 0.75rem" }}>
                          {europeanFormatWithSymbol(row.grosswage)}
                        </td>
                        <td style={{ padding: "0.5rem 0.75rem" }}>
                          {europeanFormatWithSymbol(row.employeeTax)}
                        </td>
                        <td style={{ padding: "0.5rem 0.75rem" }}>
                          {europeanFormatWithSymbol(
                            calculateNetWage(row.grosswage, row.employeeTax)
                          )}
                        </td>
                        <td style={{ padding: "0.5rem 0.75rem" }}>
                          {europeanFormatWithSymbol(row.companyTax)}
                        </td>
                        <td style={{ padding: "0.5rem 0.75rem" }}>
                          {europeanFormatWithSymbol(
                            calculateTotalPayrollCost(
                              row.grosswage,
                              row.companyTax
                            )
                          )}
                        </td>
                        <td style={{ padding: "0.5rem 0.75rem" }}>
                          <input
                            type="checkbox"
                            checked={row.selected || false}
                            onChange={() => handleItemToggle(index)}
                            disabled
                          />
                        </td>
                      </tr>
                    ))}
                    <tr
                      className="off-cycle-header edit-payroll-footer"
                      style={{
                        borderTop: "0.5px solid rgb(243, 236, 236)",
                        position: "absolute",
                        bottom: "0",
                        display: "flex",
                        width: "100%",
                      }}
                    >
                      <th style={{ padding: "0.5rem 0.75rem" }}>
                        <div style={{ display: "flex", alignItems: "center" }}>
                          {"Totals"}
                        </div>
                      </th>
                      <th style={{ padding: "0.5rem 0.75rem" }}>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          {/* total grossWage */}
                          {europeanFormatWithSymbol(
                            rows[0]?.payrollExpense.reduce(
                              (acc, curr) => +acc + +curr.grosswage,
                              0
                            )
                          )}
                        </div>
                      </th>
                      <th style={{ padding: "0.5rem 0.75rem" }}>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          {/* total employeeTax */}
                          {europeanFormatWithSymbol(
                            rows[0]?.payrollExpense.reduce(
                              (acc, curr) => +acc + +curr.employeeTax,
                              0
                            )
                          )}
                        </div>
                      </th>
                      <th style={{ padding: "0.5rem 0.75rem" }}>
                        {/* total net wages */}
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          {europeanFormatWithSymbol(
                            rows[0]?.payrollExpense.reduce(
                              (acc, curr) =>
                                +acc +
                                calculateNetWage(
                                  +curr.grosswage,
                                  +curr.employeeTax
                                ),
                              0
                            )
                          )}
                        </div>
                      </th>
                      <th style={{ padding: "0.5rem 0.75rem" }}>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          {europeanFormatWithSymbol(
                            rows[0]?.payrollExpense.reduce(
                              (acc, curr) => +acc + +curr.companyTax,
                              0
                            )
                          )}
                        </div>
                      </th>
                      <th style={{ padding: "0.5rem 0.75rem" }}>
                        {/* total payroll cost */}
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          {europeanFormatWithSymbol(
                            rows[0]?.payrollExpense.reduce(
                              (acc, curr) =>
                                acc +
                                calculateTotalPayrollCost(
                                  +curr.grosswage,
                                  curr.companyTax
                                ),
                              0
                            )
                          )}
                        </div>
                      </th>
                      <th>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          {
                            rows[0]?.payrollExpense.filter(
                              (item) => item.selected
                            ).length
                          }
                          -{rows[0]?.payrollExpense.length}
                        </div>
                      </th>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            {/* {rows[0]?.payrollExpense.length > 0 && (
              <div className="align-text-bottom stock-pagination">
                <Pagination
                  perPage={perPage}
                  setPerPage={setPerPage}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  totalPages={totalPages}
                />
              </div>
            )} */}
          </div>
        </div>
      </div>
      <Modal
        visible={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={null}
        width={"427px"}
        height={"284px"}
        closeIcon={false}
        style={{ background: "#FAFAFA" }}
        className="schedule-modal payroll-modal"
      >
        <div
          style={{
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            width: "100%",
            background: "#FAFAFA",
          }}
        >
          <p>
            {rows[0]?.payrollExpense.filter((item) => !item.selected).length}{" "}
            record was not selected. Another payroll was created with extension
            01 and Status Not Submitted.
          </p>
          <div className="d-flex w-100 justify-content-center mt-5">
            <button
              style={{
                backgroundColor: "#003766",
                color: "white",
                padding: "10px 20px",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
                width: "fit-content",
              }}
              onClick={handleSubmit}
            >
              Ok
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default PayrollStatus;
